module.exports = __webpack_public_path__ + "img/house.7757dc84.webp";